namespace Roodik.Core
{
	export class Utility
	{
		public static randomInteger(min, max)
		{
			var rand = min - 0.5 + Math.random() * (max - min + 1);
			rand = Math.round(rand);
			return rand;
		}

		public static randomFloat(min, max)
		{
			var rand = min - 0.5 + Math.random() * (max - min + 1);
			return rand;
		}
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Core/Utility/Utility.ts